<template>
  <div>
    <span v-for="status in statuses" :key="status.key">
      <span v-for="sticker in stickers" :key="sticker" class="text">
        <sui-popup v-if="sticker == status.key" mini>
          <div slot="trigger" :class="status.key" class="job-sticker">
            {{ status.name }}
          </div>
          <sui-popup-content>
            <div class="content-detail">
              {{ status.popup }}
            </div>
          </sui-popup-content>
        </sui-popup>
      </span>
    </span>
  </div>
</template>

<script>
import Vue from 'vue'
import PortalVue from 'portal-vue'
Vue.use(PortalVue)

export default {
  name: 'JobStatusSticker',

  props: {
    stickers: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  data() {
    return {
      statuses: [
        {
          key: 'new',
          name: 'New',
          popup: 'Newly updated! First come, First serve!',
        },
        {
          key: 'urgent',
          name: 'Urgent',
          popup: 'Recommended to focus, employers highly expect candidates',
        },
        {
          key: 'offering',
          name: 'Offering',
          popup:
            'Not recommended to focus since 1 or more candidates are on offering process',
        },
        {
          key: 'many_applicants',
          name: ' Many applicants',
          popup:
            'Not recommended to focus since it already got too many applicants',
        },
        {
          key: 'no_applicant',
          name: 'No applicant',
          popup: 'Recommended to focus, no competitors yet!',
        },
      ],
    }
  },
}
</script>

<style scoped lang="scss">
@import 'stylesheets/global';

.text {
  display: inline-flex;
  margin-bottom: 10px;
}

.job-sticker {
  border-radius: 100rem;
  color: $white;
  cursor: pointer;
  display: inline-flex;
  /* stylelint-disable-next-line declaration-no-important */
  font-family: 'Poppins', sans-serif !important;
  font-size: 12px;
  font-weight: 500;
  margin-right: 5px;
  padding: 2px 8px;
  white-space: nowrap;

  &.new {
    background: #a55eea;
  }
  /* stylelint-disable-next-line selector-class-pattern */
  &.no_applicant {
    background: #9a9a9a;
  }
  &.offering {
    background: #00a8ff;
  }
  &.urgent {
    background: #ee5253;
  }
  /* stylelint-disable-next-line selector-class-pattern */
  &.many_applicants {
    background: #20bf6b;
  }
}

@media only screen and (max-width: 991px) {
  .job-sticker {
    font-size: 10px;
  }
}
</style>
